export enum PaymentMethod {
  AFTERPAY = "afterpay",
  ALIPAY = "alipay",
  AMEX = "amex",
  BANCONTACT = "bancontact",
  BLIK = "blik",
  CARTA_SI = "cartaSi",
  CARTE_BLEUE = "carteBleue",
  DANKORT = "dankort",
  EPS = "eps",
  GIROPAY = "giropay",
  IDEAL = "ideal",
  KLARNA = "klarna",
  MASTER_VISA = "masterVisa",
  MULTIBANCO = "multibanco",
  MY_BANK = "myBank",
  NEXI = "nexi",
  PAYPAL = "paypal",
  POSTEPAY = "postepay",
  PRZELEWY24 = "przelewy24",
  SEPA = "sepa",
  SOFORT = "sofort",
  TRUSTLY = "trustly"
}



// WEBPACK FOOTER //
// ./src/payments.ts